var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-number-group"},[_c('div',[_vm._v("\n    任务总数: "),_c('span',[_vm._v(_vm._s(_vm.number.total))])]),_vm._v(" "),_c('div',[_vm._v("\n    当前待处理总数: "),_c('span',[_vm._v(_vm._s(_vm.number.plan))])]),_vm._v(" "),_c('div',[_vm._v("\n    当前已扫总数: "),_c('span',[_vm._v(_vm._s(_vm.number.amount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }